import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { merchantApi } from "@api";
import {
    ComponentHeaderAuth,
    ComponentPopUpTerms,
    StyledContainerSocial,
    StyledSignUp,
} from "@components";
import { enumExternalMethod } from "@configs";
import { ModuleEmail, ModulePreType, ModuleSocial, ModuleTel } from "@modules";
import { getTerms, selectAuth, selectMerchant, store } from "@redux";
import { Skeleton } from "antd";
import { useHistory } from "react-router";
import styled from "styled-components";

export const PageSignUpFrom = () => {
    //page hooks

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const history = useHistory();
    useEffect(() => {
        dispatch(getTerms());
    }, []);
    const merchant = useSelector(selectMerchant);

    //redux states
    const { externalLogin, terms } = useSelector(selectAuth);
    const token = store.getState().auth.auth?.accessToken;

    // const { name } = useSelector(selectMerchant);
    //states
    const [isTerm, setIsTerm] = useState<boolean>(false);
    const [isConfirm, setIsConfirm] = useState<boolean>(false);
    const [showPreType, setshowPreType] = useState<boolean>(false);
    const [isLoading, setIsloading] = useState(true);
    const [isFullName, setIsFullName] = useState();

    const getIsFullName = async () => {
        try {
            const res = await merchantApi.getIsFullName();
            if (res.data) {
                setIsFullName(res.data.isFullName);
            }
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        getIsFullName();
    }, []);

    const handleChangeTerm = (e: boolean) => {
        setIsTerm(!isTerm);
    };

    useEffect(() => {
        fetchMemberType();
        setIsloading(false);
    }, [token]);

    const fetchMemberType = () => {
        if (merchant?.memberTypeConfig?.isActive && merchant?.memberTypeConfig?.isPreform) {
            setshowPreType(true);
        }
    };

    const render = () => {
        console.log("externalLogin", externalLogin);
        switch (externalLogin) {
            case enumExternalMethod.EMAIL:
                return <ModuleEmail handleChangeTerm={handleChangeTerm} showTerm={false} />;

            case enumExternalMethod.FACEBOOK:
                return (
                    <ModuleSocial
                        handleChangeTerm={handleChangeTerm}
                        showTerm={false}
                        isConfirm={isConfirm}
                        isFullName={isFullName}
                    />
                );

            case enumExternalMethod.GOOGLE:
                return (
                    <ModuleSocial
                        handleChangeTerm={handleChangeTerm}
                        showTerm={false}
                        isConfirm={isConfirm}
                        isFullName={isFullName}
                    />
                );

            case enumExternalMethod.LINE:
                return (
                    <ModuleSocial
                        handleChangeTerm={handleChangeTerm}
                        showTerm={false}
                        isConfirm={isConfirm}
                        isFullName={isFullName}
                    />
                );

            case enumExternalMethod.TEL:
                return (
                    <ModuleTel
                        handleChangeTerm={handleChangeTerm}
                        showTerm={false}
                        isConfirm={isConfirm}
                        isFullName={isFullName}
                    />
                );

            default:
                break;
        }
    };
    const handleTerms = () => {
        setIsTerm(!isTerm);
        setIsConfirm(true);
    };

    const loadingComponent = (
        <StyledSkeleton>
            <div className="group-skeleton">
                <Skeleton
                    loading={isLoading}
                    active
                    title={true}
                    paragraph={{ rows: 1 }}
                ></Skeleton>
                <Skeleton
                    loading={isLoading}
                    active
                    title={true}
                    paragraph={{ rows: 1 }}
                ></Skeleton>
                <Skeleton
                    loading={isLoading}
                    active
                    title={true}
                    paragraph={{ rows: 1 }}
                ></Skeleton>
                <Skeleton
                    loading={isLoading}
                    active
                    title={true}
                    paragraph={{ rows: 1 }}
                ></Skeleton>
                <div className="twocontent-skeleton">
                    <Skeleton
                        loading={isLoading}
                        active
                        title={true}
                        paragraph={{ rows: 1 }}
                    ></Skeleton>
                    <Skeleton
                        loading={isLoading}
                        active
                        title={true}
                        paragraph={{ rows: 1 }}
                    ></Skeleton>
                    <Skeleton
                        loading={isLoading}
                        active
                        title={true}
                        paragraph={{ rows: 1 }}
                    ></Skeleton>
                    <Skeleton
                        loading={isLoading}
                        active
                        title={true}
                        paragraph={{ rows: 1 }}
                    ></Skeleton>
                    <Skeleton
                        loading={isLoading}
                        active
                        title={true}
                        paragraph={{ rows: 1 }}
                    ></Skeleton>
                    <Skeleton
                        loading={isLoading}
                        active
                        title={true}
                        paragraph={{ rows: 1 }}
                    ></Skeleton>
                </div>
            </div>
            <div className="group-skeleton">
                <div className="title-skeleton">
                    <Skeleton loading={isLoading} active title={true} paragraph={false}></Skeleton>
                </div>
                <Skeleton
                    loading={isLoading}
                    active
                    title={true}
                    paragraph={{ rows: 1 }}
                ></Skeleton>
                <div className="twocontent-skeleton">
                    <Skeleton
                        loading={isLoading}
                        active
                        title={true}
                        paragraph={{ rows: 1 }}
                    ></Skeleton>
                    <Skeleton
                        loading={isLoading}
                        active
                        title={true}
                        paragraph={{ rows: 1 }}
                    ></Skeleton>
                    <Skeleton
                        loading={isLoading}
                        active
                        title={true}
                        paragraph={{ rows: 1 }}
                    ></Skeleton>
                    <Skeleton
                        loading={isLoading}
                        active
                        title={true}
                        paragraph={{ rows: 1 }}
                    ></Skeleton>
                </div>
            </div>
            <div className="group-skeleton">
                <div className="title-skeleton">
                    <Skeleton loading={isLoading} active title={true} paragraph={false}></Skeleton>
                </div>
                <Skeleton
                    loading={isLoading}
                    active
                    title={true}
                    paragraph={{ rows: 1 }}
                ></Skeleton>
                <Skeleton
                    loading={isLoading}
                    active
                    title={true}
                    paragraph={{ rows: 1 }}
                ></Skeleton>
                <Skeleton
                    loading={isLoading}
                    active
                    title={true}
                    paragraph={{ rows: 1 }}
                ></Skeleton>
                <Skeleton
                    loading={isLoading}
                    active
                    title={true}
                    paragraph={{ rows: 1 }}
                ></Skeleton>
                <Skeleton
                    loading={isLoading}
                    active
                    title={true}
                    paragraph={{ rows: 1 }}
                ></Skeleton>
            </div>
        </StyledSkeleton>
    );

    return (
        <>
            {showPreType ? (
                <ModulePreType showPreType={showPreType} />
            ) : (
                <ComponentHeaderAuth>
                    <StyledSignUp>
                        <StyledContainerSocial>
                            <div className="title text-sub-header">
                                <div>
                                    {" "}
                                    {t(
                                        "page.fill_in_the_information_and_receive_special_benefits"
                                    )}{" "}
                                </div>
                            </div>
                        </StyledContainerSocial>
                        {isTerm ? (
                            <ComponentPopUpTerms
                                data={terms}
                                handleConfirm={handleTerms}
                                showTerm={isTerm}
                            />
                        ) : (
                            <></>
                        )}

                        {!isLoading ? <>{render()}</> : loadingComponent}
                    </StyledSignUp>
                </ComponentHeaderAuth>
            )}
        </>
    );
};

const StyledSkeleton = styled.div`
    .group-skeleton {
        margin-bottom: 50px;
        .title-skeleton {
            position: relative;
            padding-left: 16px;
            margin-bottom: 12px;
            .ant-skeleton-title {
                height: 10px;
                width: 84px !important;
                border-radius: 16px;
                margin-top: 5px;
                margin-bottom: 8px;
            }
            &:after {
                content: "";
                width: 4px;
                height: 19px;
                position: absolute;
                left: 0;
                top: 0;
                background-color: #000;
                border-radius: 2px;
            }
        }
        .twocontent-skeleton {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 12px;
        }
        .ant-skeleton {
            .ant-skeleton-content {
                .ant-skeleton-title {
                    height: 10px;
                    width: 84px !important;
                    border-radius: 16px;
                    margin-top: 0;
                    margin-bottom: 8px;
                }
                .ant-skeleton-paragraph {
                    margin-top: 8px;
                    li {
                        height: 53px;
                        width: 100% !important;
                        border-radius: 4px;
                    }
                }
            }
        }
    }
`;
